<template>
  <v-app id="inspire">
    <the-header />
    <v-main>
      <v-container fluid grid-list-lg>
        <upload-initiative-modal />
        <logout-modal />
        <v-alert
          v-if="isShowValidationMessage"
          v-model="isShowValidationMessage"
          :dismissible="true"
          color="pink"
          type="warning"
          outlined
          transition="scale-transition"
          style="position: fixed; margin: 0 auto; width: 90%; left: 0; right: 0; z-index: 400; top: 0; background-color: white;"
        >
          Validation error
          <!-- eslint-disable-next-line vue/require-v-for-key -->
          <div v-for="item in showValidationMessage">
            {{ item.field }}: {{ item.message }} {{ item.args.join(',') }}
          </div>
        </v-alert>
        <v-dialog
          v-model="isShowUnauthorizedMessage"
          persistent
          max-width="500px"
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-card-title>
              <h3>Logged out</h3>
            </v-card-title>
            <v-card-text>
              <p>
                You are not logged in, your session timed out, or you do not have access.
              </p>
              <p>
                Click <strong>Login</strong> to be redirected to the login page, or click <strong>Cancel</strong> to close this dialog box.
              </p>
              <p>
                Note if you click <strong>Cancel</strong>, this dialog will close, however the application may not function.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" @click.stop="redirectLogin()">Login</v-btn>
              <v-btn color="primary" @click.stop="setShowUnauthorizedMessage(false)">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <router-view />
      </v-container>
    </v-main>
    <the-footer />
    <div
      v-show="showLoadingSpinner"
      class="loading"
      aria-label="Loading..."
      aria-hidden="true"
    >
      <div class="loading-backdrop" />
      <div class="loading-icon">
        <v-progress-circular :size="100" :width="6" color="primary" indeterminate />
      </div>
    </div>
    <v-snackbar
      v-model="isShowErrorMessage"
      :bottom="true"
      :timeout="10000"
    >
      An Error Occured
      <v-btn text color="red" @click.native="setShowErrorMessage(false)">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import TheHeader from '@/components/header/TheHeader'
import TheFooter from '@/components/footer/TheFooter'
import { mapState, mapMutations } from 'vuex'
import UploadInitiativeModal from '@/components/uploadInitiative/UploadInitiativeModal'
import LogoutModal from '@/components/header/LogoutModal'
export default {
  name: 'app',
  components: {
    TheHeader,
    TheFooter,
    UploadInitiativeModal,
    LogoutModal
  },
  computed: {
    ...mapState('global', ['showLoadingSpinner', 'showErrorMessage', 'showUnauthorizedMessage', 'showValidationMessage']),
    isShowValidationMessage: {
      get() {
        return this.showValidationMessage
      },
      set(value) {
        this.setShowValidationMessage(value)
      }
    },
    isShowErrorMessage: {
      get() {
        return this.showErrorMessage && !this.showUnauthorizedMessage && !this.showValidationMessage
      },
      set(value) {
        this.setShowErrorMessage(value)
      }
    },
    isShowUnauthorizedMessage: {
      get() {
        return this.showUnauthorizedMessage
      },
      set(value) {
        this.setShowUnauthorizedMessage(value)
      }
    }
  },
  methods: {
    ...mapMutations('global', ['setShowLoadingSpinner', 'setShowErrorMessage', 'setShowUnauthorizedMessage', 'setShowValidationMessage']),
    redirectLogin() {
      window.location.href = window.location.protocol + '//' + window.location.host + '/mrx-gateway/startlogin' + window.location.pathname + window.location.search
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9000;
    background-color: $black;
    opacity: .5;
  }

  .loading-icon {
    position: fixed;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 50%;
    margin: -40px 0 0 -40px;
    z-index: 10000;
    box-sizing: border-box;
  }
</style>
<style lang="scss">
  .required label:before, label.required:before {
    color: $color-danger;
    content: "*";
  }
  div.v-data-table__wrapper>table tbody tr:hover {
    background: $color-secondary !important;
  }
</style>
<style>
  html {
    overflow-x: auto;
  }
  .v-data-table__wrapper, .v-window__container {
    overflow: visible;
  }
  .v-select-list .subheader {
    padding-left: 1em;
  }
</style>
